import { render, staticRenderFns } from "./NewsEnter.vue?vue&type=template&id=4cd59acf&scoped=true&"
import script from "./NewsEnter.vue?vue&type=script&lang=js&"
export * from "./NewsEnter.vue?vue&type=script&lang=js&"
import style0 from "./NewsEnter.vue?vue&type=style&index=0&id=4cd59acf&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cd59acf",
  null
  
)

export default component.exports